import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=028574a4&scoped=true&"
import script from "./Advertisement.js?vue&type=script&lang=js&"
export * from "./Advertisement.js?vue&type=script&lang=js&"
import style0 from "./Advertisement.scss?vue&type=style&index=0&id=028574a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028574a4",
  null
  
)

export default component.exports